import { render, staticRenderFns } from "./FireAlarm.vue?vue&type=template&id=edb9e1c2&scoped=true&"
import script from "./FireAlarm.vue?vue&type=script&lang=ts&"
export * from "./FireAlarm.vue?vue&type=script&lang=ts&"
import style0 from "./FireAlarm.vue?vue&type=style&index=0&id=edb9e1c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb9e1c2",
  null
  
)

component.options.__file = "FireAlarm.vue"
export default component.exports